export var defaultXAxisConfig = {
    type: 'ntb',
    asFooter: true,
    displayGridLines: true,
    noDraw: false,
    height: 30,
};
export var defaultYAxisConfig = {
    displayGridLines: true,
    drawCurrentPriceLabel: true,
    goldenRatio: true,
    noDraw: false,
    position: 'right',
};
//# sourceMappingURL=axisConfiguration.js.map